// src/pages/CircleRedirectPage.js
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';

const CircleRedirectPage = () => {
  const { shortCode } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOriginalUrl = async () => {
      try {
        const response = await fetch(`/api/c/${shortCode}/`);
        const data = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(data.error || "This link isn't valid");

        navigate(`/circle/${data.circleId}`, { 
          state: { 
            circleId: data.circleId,
            fromShortLink: true 
          }
        });
      } catch (err) {
        setError(err.message);
      }
    };

    fetchOriginalUrl();
  }, [shortCode, navigate]);

  if (error) {
    return (
      <Box 
        display="flex" 
        flexDirection="column" 
        alignItems="center" 
        justifyContent="center" 
        minHeight="100vh"
      >
        <Typography color="error" variant="h6" role="alert">
          {error}
        </Typography>
      </Box>
    );
  }

  return (
    <Box 
      display="flex" 
      alignItems="center" 
      justifyContent="center" 
      minHeight="100vh"
    >
      <CircularProgress aria-label="Loading" />
    </Box>
  );
};

export default CircleRedirectPage;